<template>
  <component :is="renderAs" v-if="renderAs" data-test="variant-link" :class="classes" @click="onClick">
    <slot />
  </component>
  <NuxtLink v-else-if="hasVariantSlug" data-test="variant-link" :class="classes" :to="route" @click="onClick">
    <slot />
  </NuxtLink>
  <span v-else data-test="variant-link" :class="classes">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { useProductStore } from '@/stores';
import type { Variant } from '@/types/products';

type ExtendedVariant = Variant & {
  variantSlug?: string;
  productId?: string;
};

type Props = {
  list: string;
  variant: ExtendedVariant;
  renderAs?: string;
};

const props = withDefaults(defineProps<Props>(), {
  renderAs: undefined,
});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const router = useRouter();
const { $tracking } = useNuxtApp();
const { pushProductHistory } = useProductStore();

const hasVariantSlug = computed(() => !!props.variant.variantSlug);

const route = computed(() => (hasVariantSlug.value ? linkToPdp(props.variant.variantSlug!) : ''));

const classes = computed(() => (!props.variant.variantSlug ? 'cursor-default' : 'cursor-pointer flex'));

const onClick = () => {
  if (router.currentRoute.value.name === 'kategorier-slug' || router.currentRoute.value.name === 'search') {
    pushProductHistory({
      productId: props.variant.productId,
      variant: props.variant.articleNumber,
    });
  }
  if (!router.currentRoute.value.path.includes(props.variant.variantSlug!)) {
    $tracking.emit('variantClick', {
      variant: props.variant,
      pageType: router.currentRoute.value.name,
      list: props.list,
    });
    if (props.renderAs) router.push(linkToPdp(props.variant.variantSlug));
  }

  emit('close');
};
</script>

<script lang="ts">
export default defineComponent({
  name: 'VariantLink',
});
</script>
